// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.RentalManagerUserInfoV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerAuthCheckUserInfoDto } from '../..';

interface GetParams {
  allowedSessionLengthSeconds?: number;
  extendSession?: boolean;
  includeCanClaimFreeListings?: boolean;
  includeCustomers?: boolean;
  includeProfileImageUrl?: boolean;
  pageWithSensitiveInformation?: boolean;
}

export const RentalManagerUserInfoV2WebApiHandler_get_Path = '/api/web/v2/users/get';

/**
 * Get data for a user; Used by all clients except mobile apps
 */
export const RentalManagerUserInfoV2WebApiHandler_get = (getParams: GetParams, client = getClient()) => {
  return httpFrontEndRequest<GetParams, never, RentalManagerAuthCheckUserInfoDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserInfoV2WebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
